import decode, { InvalidTokenError } from 'jwt-decode';
import be from './Backend';
import Vue from 'vue';
import store from '../store';

let interval = null;

let courses = [
    { code: 'mkbidee' },
    { code: 'mkbidee_course' }
];

let activeCourse = null;

function init(course)
{
    if (!course) {
        console.log('Auth init with unknown course');
        return;
    }    

    if (course == activeCourse && course.code == activeCourse.code) 
    {
        return; // no change
    }
    
    console.log('init', course, activeCourse);

    if (course == null) {
        course = courses[0];
    }

    sessionStorage.courseCode = course.code;
    activeCourse = course;

    be.MIA.setActiveCourse(activeCourse);

    return be.MIA.submitEvent('AccountEvent', 'Init', Date.now().toString()).then((data) => {
        Auth.keepalive();
    });
}

const Auth = {
    'getToken': () =>
    {
        return sessionStorage.token;
    },

    'setToken': (token, refreshToken) =>
    {   
        //console.log('setToken', token, refreshToken);     
        sessionStorage.token = token;
        sessionStorage.refreshToken = refreshToken;

        // Update 'remember me' if needed
        if (Vue.$cookies.get('token')) { 
            Vue.$cookies.set('token', sessionStorage.refreshToken);
        }
    },

    'removeToken': () => 
    {
        //console.log('removeToken');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('refreshToken');
        sessionStorage.removeItem('courseCode');
    },

    'setCourseCode': (courseCode) => 
    {
        sessionStorage.courseCode = courseCode;
    },

    'getRefreshToken': () => 
    {
        if (!sessionStorage.refreshToken) {
            sessionStorage.refreshToken = Vue.$cookies.get('token');
        }

        return sessionStorage.refreshToken;        
    },   

    'isLoggedIn': () =>
    {
        let role = false;

        if (sessionStorage.token) {        

            try {
                let data = decode(sessionStorage.token);
                /*
                if (data.exp < Date.now() / 1000) {
                    sessionStorage.removeItem('token');
                    return false;
                }
                */

                role = data.role;
            }
            catch(e) {
                if(e instanceof InvalidTokenError) {
                    return false;
                }

                throw e;
            }

            // Make sure course is initialized
            if (sessionStorage.courseCode) {
                let course = courses.find((course) => course.code == sessionStorage.courseCode);
                init(course);                
            }

            return role;
        }

        return false;
    },

    'login': (email, password) =>
    {
        return be.login(email, password)
            .then((data) => 
            {
                Auth.setToken(data.access_token, data.refresh_token);
                be.MIA.removeToken();
                store.commit('setLoggedIn', Auth.isLoggedIn());
                
                if (Auth.isLoggedIn() == 'seeker') {
                    return be.MIA.findActiveCourse(courses);
                } else {
                    return true;
                }
            })
            .fail(() => {
                Auth.removeToken();
            })
            .done((course) => {
                return init(course);
            })
    },

    'loginWithRefreshToken': () => 
    {
        if (sessionStorage.token) {            
            try {
                let data = decode(sessionStorage.token);                
                if (data.exp < Date.now() / 1000) {
                    sessionStorage.removeItem('token');
                } else {
                    // valid
                    return Promise.resolve();
                }
            }
            catch(e) {
                if(!(e instanceof InvalidTokenError)) {
                    throw e;
                }            
            }            
        }

        if (Auth.getRefreshToken()) {

            return be.refreshToken().then((data) => {
                Auth.setToken(data.access_token, data.refresh_token);
                store.commit('setLoggedIn', Auth.isLoggedIn());

                if (Auth.isLoggedIn() == 'seeker') {
                    return be.MIA.findActiveCourse(courses);
                } else {
                    return true;
                }
            })
            .fail(() => {
                Auth.removeToken();
            })
            .done((course) => {
                return init(course);
            })
        } 

        return Promise.resolve();
    },

/*
    'loginToken': (token) => 
    {
        Auth.setToken(token);
                
        return be.MIA.findActiveCourse(courses)
            .fail(() => {
                Auth.removeToken();
            })
            .done((course) => {
                return init(course);
            });
    },
*/    

    'logout': () =>
    {
        Auth.removeToken();
        be.MIA.removeToken();

        if(window.$vm) {
            if(window.$vm.$cookies.isKey("token")) {
                window.$vm.$cookies.remove("token");
            }
        }

        store.commit('setLoggedIn', false);
    },

    'keepalive': () =>
    {
        if (!interval) {
            be.MIA.submitEvent('CourseEvent', 'Starting keep alive', Date.now());

            interval = setInterval(() => {
                be.MIA.submitKeepAlive()
            }, 1000 * 120);
        }
    }
};

export default Auth;
